import { createMiddlewareAction } from "./createMiddlewareAction"
import { endpoints } from "../api/endpoints"
import { userTypes } from "../constantes/actionTypes"

export const authActions = {
    getUserProfileAuth: () => (
        createMiddlewareAction({ 
            successType: userTypes.LOGIN_SUCCESS,
            failureType: userTypes.LOGIN_FAILURE,
            method: "GET",
            endpoint: endpoints.GET_PROFILE_USER_AUTH,
    })
  ),
}
